import { Component, Input } from '@angular/core';
import { PageItem } from '../../core/search-pages.model';

import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'page-item',
  standalone: true,
  imports: [I18nModule],
  templateUrl: './page-item.component.html',
  styleUrl: './page-item.component.scss',
})
export class PageItemComponent {
  @Input() page!: PageItem;
}
